import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import FundingApprovalsIndexDataTable from './components/FundingApprovalsIndexDataTable';
import ReviewFundingModal from './components/ReviewFundingModal';

const FundingApprovalsIndex = () => {
  const [review, setReview] = useState({ holdId: null, isOpen: false, refresh: null });

  const onReview = (row, refresh) => setReview({ holdId: row.id, isOpen: true, refresh });
  const toggle = () => setReview((r) => ({ ...r, isOpen: false }));
  const onResult = () => review.refresh && review.refresh();

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Funding Approvals</h3>
          <h3 className="page-subhead subhead"><Link to="/">Home</Link> / Funding Approvals</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <FundingApprovalsIndexDataTable onReview={onReview} />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ReviewFundingModal key={review.holdId} holdId={review.holdId} isOpen={review.isOpen} toggle={toggle} onResult={onResult} />
    </Container>
  );
};

export default FundingApprovalsIndex;
